import React from 'react';
import { Link } from 'react-router-dom';
import BRANDLOGO from '../images/bluebus.png';

const FooterComponent = () => {
  return (
    <>
      <div className='px-6 mt-20 flex gap-10 lg:gap-16 lg:pl-20 lg:pr-20   pt-8 pb-5 bg-[#fafdff] '>
        <div className='flex-col gap-2 w-[35%] hidden lg:block'>
          <img src={BRANDLOGO} className='w-20 lg:w-24 h-12' />
          <p className='text-gray-600 hidden lg:block'>BlueBus largest online bus ticket booking service trusted by over 25 million happy customers. BlueBus offers bus ticket booking through its website for all major routes.</p>
        </div>
        <div className='flex-col w-[25%] space-y-1'>
          <p className='text-sm mb-2 text-gray-400 font-semibold'>COMPANY</p>
          <p className='cursor-pointer '>About</p>
          <p className='cursor-pointer'>Contact</p>
          <p className=' cursor-pointer'>Careers</p>
          <p className=' cursor-pointer'>Offers</p>

        </div>
        <div className='flex-col  w-[25%] space-y-1'>
          <p className='text-sm mb-4 text-gray-400 font-semibold'>INFO</p>
          <p className='cursor-pointer '>Privacy</p>
          <Link to="/operator"> <p className='cursor-pointer'>Operator</p></Link>
          <Link to="/operator/requestform"> <p className=' cursor-pointer'>Bus Operator Registration</p></Link>
          <Link to="/admin/operators"> <p className=' cursor-pointer'>Admin</p></Link>

        </div>
        <div className='flex-col  w-[25%] space-y-1'>
          <p className='text-sm mb-4 text-gray-400 font-semibold'>SUPPORT</p>
          <p className='cursor-pointer '>Help</p>


        </div>


      </div>
      <div className='border h-0 '></div>
      <div className='text-gray-400 py-3 flex  justify-center bg-[#fafdff]'>
        <p> © 2023 BlueBus. All Right Reserved</p>
      </div>
    </>
  )
}

export default FooterComponent